import { addLocaleData } from 'react-intl';
import enLang from './entries/en-US';
import elLang from './entries/el-EL';

const AppLocale = {
    en: enLang,
    el: elLang
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.el.data);

export default AppLocale;
